export const CHAT_COMPOSER_INSERT_TEXT_EVENT =
  "guesteria:chat-composer-insert-text";

export interface ChatComposerInsertTextEventDetail {
  text: string;
  mode?: "insert" | "replace";
}

export function dispatchChatComposerInsertText(
  detail: ChatComposerInsertTextEventDetail,
) {
  window.dispatchEvent(
    new CustomEvent<ChatComposerInsertTextEventDetail>(
      CHAT_COMPOSER_INSERT_TEXT_EVENT,
      { detail },
    ),
  );
}
